import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';

// Get environment variables from window.ENV (created at runtime) or fallback to process.env (build-time)
const windowEnv = (window as any).ENV || {};

const options = {
  api_host: windowEnv.REACT_APP_PUBLIC_POSTHOG_HOST || process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
  persistence: 'localStorage+cookie' as const,
  cross_subdomain_cookie: true,
}

const apiKey = windowEnv.REACT_APP_PUBLIC_POSTHOG_KEY || process.env.REACT_APP_PUBLIC_POSTHOG_KEY || '';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <PostHogProvider 
      apiKey={apiKey}
      options={options}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
); 